import { useState } from "react"
import back from "../../../assets/periGum/back.png"
import close from "../../../assets/periGum/close.png"
import ProfileForm from "./profile"
import ReasonsForm from "./reasons"
import { useNavigate } from "react-router-dom"

const Form = ({ setFormOpen, setFormCompleted, submit }) => {
    const navigate = useNavigate()
    const [isForm1, setIsForm1] = useState(true);
    const [form2values, setForm2Values] = useState()
       const [form1Values, setForm1Values] = useState({
        name: "",
        email: "",
        gender: "",
        age: ""
    })

    const goBack = () => {
        isForm1 ? setFormOpen(false) : setIsForm1(true)
    }
    return (
        <div className="h-full flex flex-col">
            <div className="flex justify-between p-2 mb-5">
                <button type="button" onClick={goBack} >
                    <img src={back} alt="back button" className="h-9" />
                </button>
                <button type="button" onClick={goBack} >
                    <img src={close} alt="back button" className="h-9" />
                </button>
            </div>
            {
                // !isForm1 ? <ProfileForm setFormOpen={setFormOpen}  form2values={form2values} form1Values={form1Values} setForm1Values={setForm1Values}  />
                //     :
                     <ReasonsForm  setForm2Values={setForm2Values} setIsForm1={setIsForm1}  setFormCompleted={setFormCompleted} submit={submit}  />
            }


        </div>
    )
}

export default Form